import { compactObject } from "utils/compactObject";
import { YEARLY_BILLING_INTERVAL } from "utils/insurance";
import { ProductEnum } from "../../../../../__generated__/globalTypes";
import { State } from "components/Signup/store/state/types";
import { selectMetadata } from "components/Signup/store/selectors/metadata";
import { getLiabilityPackages } from "components/Signup/config/ger/plans-liability";
import { selectCustomer } from "components/Signup/store/selectors/customer";
import { selectAllValidAnimals } from "components/Signup/store/selectors/animals";

function getMetadataFromState(state: State): Record<string, any> {
  const metadata = selectMetadata(state);

  return {
    deviceId: metadata.deviceId,
    sessionId: metadata.sessionId,
  };
}

export function getMultipetStateFromState(state: State): Record<string, any> {
  const animals = selectAllValidAnimals(state);
  const { deductible, limit, copay, discountCode, billingInterval, startDate } =
    animals[0].insurances[0];

  return compactObject({
    ...getMetadataFromState(state),
    ...selectCustomer(state),
    billingInterval,
    deductible,
    limit,
    copay,
    discountCode,
    startDate,
  });
}

export function getLiabilityStateFromState(state: State): Partial<State> {
  const {
    name,
    species,
    birthday,
    breed,
    mixedBreedFHalf,
    mixedBreedSHalf,
    sex,
    sexSituation,
    insurances,
  } = selectAllValidAnimals(state)[0];

  const { startDate } = insurances[0];

  const packages = getLiabilityPackages(species);

  const defaultPackage = packages.find((pack) => !!pack.default) || packages[0];

  return compactObject({
    ...getMetadataFromState(state),
    ...selectCustomer(state),
    name,
    species,
    birthday,
    breed,
    mixedBreedFHalf,
    mixedBreedSHalf,
    sex,
    sexSituation,
    isDraft: false,
    product: ProductEnum.liability,
    discountCode: "ALLIN5",
    nextStep: "loading",
    limit: defaultPackage.limit,
    deductible: defaultPackage.deductible ?? 0,
    copay: 0,
    billingInterval: YEARLY_BILLING_INTERVAL,
    startDate,
  });
}
